import SearchPage from './search-page-wrapper'

export * from './search-page'
export { SearchPageWrapper } from './search-page-wrapper'
export default SearchPage
